function stream(state = {}, action) {
  const newState = { ...state }
  switch (action.type) {
    case 'CLOSE_STREAM':
      const thisStream = newState[action.name.toUpperCase()]?.['stream']
      if (thisStream != null) {
        thisStream.close()
      }
      delete newState[action.name.toUpperCase()]
      return newState
    case 'OPEN_STREAM':
      // note clinic_waitlist and waitlist should be treated as the same
      newState[
        action.name.toUpperCase().replace('CLINIC_WAITLIST', 'WAITLIST')
      ] = { stream: action.result }
      return newState
    case 'STORE_WAITLIST_STREAM':
    case 'STORE_CLINIC_WAITLIST_STREAM':
      const lastUpdatedAt =
        action.result.length > 0
          ? action.result[action.result.length - 1].updated_at
          : null
      return {
        ...newState,
        WAITLIST: {
          ...newState.WAITLIST,
          last_updated_at: lastUpdatedAt
        }
      }
    default:
      return state
  }
}

export default stream
